import React from 'react';
import MergedPage from '../components/nav/MergedPage';
import DailyInvoices from './DailyInvoices';
import Billing from './Billing';

// Invoices (Sep 2026 nav restructure): Daily Invoices + Billing as tabs.
export default function InvoicesPage() {
  const tabs = [
    { key: 'daily', label: 'Daily Invoices', render: () => <DailyInvoices /> },
    { key: 'billing', label: 'Billing', render: () => <Billing /> },
  ];
  return <MergedPage tabs={tabs} defaultTab="daily" testId="invoices-page" />;
}
